import * as React from 'react';
import * as _ from 'lodash';
import classNames from 'classnames';
export default function () {
    function onClick1(values, isOpened, activeValue, disabled, underlineText, label, intl, handleChange) {
        {
            return !disabled ? handleChange() : null;
        }
    }
    function onClick2(values, isOpened, activeValue, disabled, underlineText, label, intl, handleChange) {
        {
            return !disabled ? handleChange() : null;
        }
    }
    function onClick3(values, isOpened, activeValue, disabled, underlineText, label, intl, handleChange) {
        {
            return !disabled ? handleChange() : null;
        }
    }
    function onClick4(values, isOpened, activeValue, disabled, underlineText, label, intl, handleChange, value, valueIndex) {
        handleChange(value);
    }
    function repeatValue5(values, isOpened, activeValue, disabled, underlineText, label, intl, handleChange, value, valueIndex) {
        return React.createElement('div', {
            'key': value.id || value,
            'onClick': onClick4.bind(this, values, isOpened, activeValue, disabled, underlineText, label, intl, handleChange, value, valueIndex),
            'className': 'dropdown-right-button-opened'
        }, '\r\n        ', value && value.text || value, '\r\n      ');
    }
    function scopeValuesIsOpenedActiveValueDisabledUnderlineTextLabelIntlHandleChange6() {
        var values = this.state.values;
        var isOpened = this.state.isOpened;
        var activeValue = this.state.activeValue;
        var disabled = this.state.disabled;
        var underlineText = this.state.underlineText;
        var label = this.props.label;
        var intl = this.props.intl;
        var handleChange = this.handleChange;
        return React.createElement('div', { 'ref': this.setRootRef }, label ? React.createElement('div', {
            'className': classNames('ui-input3-title', { 'disabled': disabled }),
            'onClick': onClick1.bind(this, values, isOpened, activeValue, disabled, underlineText, label, intl, handleChange),
            'key': '489'
        }, label) : null, React.createElement('span', { 'className': 'dropdown-container' }, React.createElement('div', {
            'className': classNames('dropdown-left-button', { 'disabled': disabled }),
            'onClick': onClick2.bind(this, values, isOpened, activeValue, disabled, underlineText, label, intl, handleChange)
        }), React.createElement.apply(this, [
            'span',
            { 'className': classNames('dropdown-values-container', { 'dropdown-values-container--opened': isOpened }) },
            React.createElement('div', {
                'className': classNames({ 'dropdown-right-button-closed': !isOpened }, { 'disabled': disabled }, { 'dropdown-right-button-opened': isOpened }),
                'onClick': onClick3.bind(this, values, isOpened, activeValue, disabled, underlineText, label, intl, handleChange)
            }, '\r\n        ', activeValue && activeValue.text ? activeValue.text : activeValue || intl.formatMessage({ id: 'select.defaultValue' }), '\r\n      '),
            isOpened ? _.map(values.filter(val => val.id ? val.id !== activeValue.id : val !== activeValue), repeatValue5.bind(this, values, isOpened, activeValue, disabled, underlineText, label, intl, handleChange)) : null
        ])), underlineText ? React.createElement('div', {
            'className': classNames('dropdown-underline-text', { 'disabled': disabled }),
            'key': '1642'
        }, underlineText) : null);
    }
    return scopeValuesIsOpenedActiveValueDisabledUnderlineTextLabelIntlHandleChange6.apply(this, []);
}